/**
 * Simple throttle function that executes a passed function only once in the specified timeout
 * @param handlerFunc
 * @param [timeout] the throttle interval
 */
 const activityTypes = [
  {
    number: 0,
    type: "UNKNOWN",
    label: "unbekannt"
  },
  {
    number: 1,
    type: "RUNNING",
    label: "laufen"
  },
  {
    number: 2,
    type: "HIKING",
    label: "gehen/wandern"
  },
  {
    number: 3,
    type: "CYCLING",
    label: "radfahren"
  },
  {
    number: 4,
    type: "SWIMMING",
    label: "schwimmen"
  },
  {
    number: 5,
    type: "WORKOUT",
    label: "workout"
  },
  {
    number: 6,
    type: "SKIING",
    label: "ski"
  },
  {
    number: 7,
    type: "SKIING-NORDIC",
    label: "nordic-ski"
  },
  {
    number: 8,
    type: "SKATING",
    label: "skaten"
  },
  {
    number: 9,
    type: "SNOWBOARDING",
    label: "snowboarden"
  },
  {
    number: 10,
    type: "BADMINTON",
    label: "badminton"
  },
  {
    number: 11,
    type: "GOLF",
    label: "golf"
  },
  {
    number: 12,
    type: "YOGA",
    label: "yoga"
  },
  {
    number: 999,
    type: "NONE",
    label: "---"
  }
];

const activityExternalSource = [
    { number: 1, value: "Fitbit"},
    { number: 2, value: "Garmin"},
    { number: 3, value: "Polar"},
    { number: 5, value: "Apple"},
    { number: 6, value: "Samsung"},
    { number: 7, value: "Misfit"},
    { number: 8, value: "Withings"},
    { number: 9, value: "Thryve Connector"},
    { number: 10, value:  "Thryve Wearable Connector"},
    { number: 11, value:  "Strava"},
    { number: 12, value:  "GoogleFit REST"},
    { number: 13, value:  "Xiaomi"},
    { number: 14, value:  "MyFitnessPal"},
    { number: 15, value:  "Runtastic"},
    { number: 16, value:  "OmronConnect"},
    { number: 17, value:  "Suunto"},
    { number: 18, value:  "Oura"},
    { number: 19, value:  "Runkeeper"},
    { number: 20, value:  "Endomondo"},
    { number: 21, value:  "iHealth"},
    { number: 22, value:  "Abbott (FreeStyleLibre)"},
    { number: 23, value:  "i-Sens"},
    { number: 24, value:  "Sleep As Android"},
    { number: 25, value:  "Clue"},
    { number: 26, value:  "HealthForYou"},
    { number: 27, value:  "Beurer"},
    { number: 29, value:  "OmronWellness"},
    { number: 30, value:  "Lykon"},
    { number: 31, value:  "Lifesum"},
    { number: 32, value:  "Ovy"},
    { number: 33, value:  "Motiv"},
    { number: 34, value:  "Medisafe"},
    { number: 35, value:  "B.Braun"},
    { number: 36, value:  "RocheAccu-chek"},
    { number: 37, value:  "Biomes"},
    { number: 40, value:  "Sports4Me"},
];

const takeActivity = [
    {
        number: 0,
        type: "none"
    },
    {
        number: 1,
        type: "first"
    },
    {
        number: 2,
        type: "last"
    },
    {
        number: 3,
        type: "best"
    },
    {
        number: 4,
        type: "all"
    },
    {
        number: 5,
        type: "accumulate_first_x"
    },
    {
        number: 6,
        type: "accumulate_last_x"
    }
];

const rankingStrategyType = [
    {
        number: 0,
        type: "none"
    },
    {
        number: 1,
        type: "distance"
    },
    {
        number: 2,
        type: "time"
    }
];

export default {
  getActivities() {
    return activityTypes;
  },
  getActivityType(ID) {
    let activity = ID ? activityTypes.find(e => e.number == ID) : "";
    return activity.type;
  },
  getActivityLabel(ID) {
    let activity = ID ? activityTypes.find(e => e.number == ID) : "";
    return activity.label;
  },
  formatActitivityIcon: activityType => {
    const icons = {
      1: "fas fa-running",
      2: "fas fa-walking",
      3: "fas fa-biking",
      4: "fas fa-swimmer",
      5: "fas fa-dumbbell",
      6: "fas fa-skiing",
      7: "fas fa-skiing-nordic",
      8: "fas fa-skating",
      9: "fas fa-snowboarding",
      10: "fas fa-shuttlecock",
      11: "fas fa-pray",
    };
    return icons[activityType] ? icons[activityType] : "fas fa-watch-fitness";
  },
  getActivitiesWithValidData() {
      return activityTypes.filter(a => a.number !== 0 && a.number !== 999);
  },
    getActivitiesWithoutNone() {
      return activityTypes.filter(a => a.number !== 999);
  },
  getSource: sourceId => {
    const icons = {
      1: "Fitbit",
      2: "Garmin",
      3: "Polar",
      5: "Apple",
      6: "Samsung",
      7: "Misfit",
      8: "Withings",
      9: "Thryve Connector",
      10: "Thryve Wearable Connector",
      11: "Strava",
      12: "GoogleFit REST",
      13: "Xiaomi",
      14: "MyFitnessPal",
      15: "Runtastic",
      16: "OmronConnect",
      17: "Suunto",
      18: "Oura",
      19: "Runkeeper",
      20: "Endomondo",
      21: "iHealth",
      22: "Abbott (FreeStyleLibre)",
      23: "i-Sens",
      24: "Sleep As Android",
      25: "Clue",
      26: "HealthForYou",
      27: "Beurer",
      29: "OmronWellness",
      30: "Lykon",
      31: "Lifesum",
      32: "Ovy",
      33: "Motiv",
      34: "Medisafe",
      35: "B.Braun",
      36: "RocheAccu-chek",
      37: "Biomes",
      40: "Sports4me"
    };
    return icons[sourceId] ? icons[sourceId] : "";
  },
  getExternalSourceById(id) {
    let source = id ? activityExternalSource.find(a => a.number == id) : '';
    return source.value;
  },
  getTakeActivity() {
      return takeActivity;
  },
  getRankingStrategy() {
    return rankingStrategyType;
  },
  clearObjectEmptyValues(receivedObj) {
      Object.keys(receivedObj).forEach(key => {
        if ((typeof receivedObj[key] === 'object' || Array.isArray(receivedObj[key])) && receivedObj[key] !== null) {
          this.clearObjectEmptyValues(receivedObj[key]);
        }
        if (receivedObj[key] === undefined || receivedObj[key] === '' || (Array.isArray(receivedObj[key]) && !receivedObj[key].length) || Object.keys(receivedObj[key]).length === 0) {
            delete receivedObj[key];
        }
      });

      return receivedObj;
  }
};
